function getScrollParent(node) {
	var isElement = node instanceof HTMLElement;
	var overflowY = isElement && window.getComputedStyle(node).overflowY;
	var isScrollable = overflowY !== "visible" && overflowY !== "hidden";

	if (!node) {
		return null;
	} else if (isScrollable && node.scrollHeight >= node.clientHeight) {
		return node;
	}

	return getScrollParent(node.parentNode) || document.body;
}

module.exports =  getScrollParent;